import { Play } from "lucide-react";

import { cx } from "@akaike/ui";

export function PlayIcon({ className }: { className?: string }) {
  return <Play className={cx("i-play", className)} fill="currentColor" strokeWidth={1.5} aria-hidden="true" />;
}
